/**
 * Created by h.nanev on 6/15/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/ModalBodyDocumentedProps";

export default class ModalBody extends React.Component {
    render() {
        let extraClasses = this.props.extraClasses || "";
        let className = extraClasses + " tq-modal-scroll";
        className += this.props.background ? " tq-content-bgr" : "";

        let classes = {
            contentWrapper: className,
            content: "tq-modal-content"
        };

        return (
            <div className={classes.contentWrapper}>
                <main className={classes.content}>{this.props.children}</main>
            </div>
        );
    }
}

ModalBody.displayName = "ModalBody";

ModalBody.propTypes = {
    extraClasses: PropTypes.string,
    background: PropTypes.bool
};

ModalBody.documentedProps = documentedProps;
